import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ParsedReplay, KillEvent } from '../MatchPage/Replay/replayParser';
import ReplayScoreboard from '../MatchPage/Replay/ReplayScoreboard';
import { AnalysisMatch } from '../../services/AnalysisService';
import { parseMatchTime } from '../../utils/matchTime';
import { teamSideInRound } from './roundSide';
import styles from './AnalysisPage.module.css';

interface AnalysisInspectPanelProps {
    replay: ParsedReplay;
    currentFrame: number;
    playerNames: Record<string, string>;
    match: AnalysisMatch;
    roundNumber: number;
    onBack: () => void;
}

const AnalysisInspectPanel: React.FC<AnalysisInspectPanelProps> = ({
    replay, currentFrame, playerNames, match, roundNumber, onBack,
}) => {
    const frame = replay.frames[currentFrame];
    if (!frame) return null;

    const isTeam1CT = teamSideInRound(match, match.team1Id, roundNumber, replay) === 'CT';
    const ctTeamName = isTeam1CT ? match.team1Name : match.team2Name;
    const tTeamName = isTeam1CT ? match.team2Name : match.team1Name;

    const roundEnd = match.roundEnds?.[roundNumber];
    const ctBuyType = roundEnd?.ctBuyType || '';
    const tBuyType = roundEnd?.tBuyType || '';

    const killCounts: Record<number, number> = {};
    replay.events
        .filter((e): e is KillEvent => e.type === 'kill' && e.frameIdx <= currentFrame)
        .forEach(k => { killCounts[k.killerSlot] = (killCounts[k.killerSlot] || 0) + 1; });

    const matchDate = parseMatchTime(match.matchTime).toLocaleDateString();

    return (
        <>
            {/* Back button is at the top so it stays visible even when the two
                scoreboards (10 rows + headers) overflow the panel's scroll area. */}
            <button className={styles.inspectBackBtn} onClick={onBack}>
                <ArrowBackIcon style={{ fontSize: 16 }} />
                Back to summary
            </button>

            <div className={styles.inspectHeader}>
                <span className={styles.inspectHeaderRound}>Round {roundNumber}</span>
                <span className={styles.inspectHeaderDate}>{matchDate}</span>
            </div>

            <div className={styles.inspectTeamHeader}>
                <span className={styles.inspectTeamName} style={{ color: '#5d79ae' }}>{ctTeamName}</span>
                {ctBuyType && <span className={styles.inspectBuyType}>{ctBuyType}</span>}
            </div>
            <ReplayScoreboard
                frame={frame}
                roster={replay.roster}
                playerNames={playerNames}
                side="CT"
                teamName={ctTeamName}
                layout="stacked"
                killCounts={killCounts}
            />

            <div style={{ height: 12 }} />

            <div className={styles.inspectTeamHeader}>
                <span className={styles.inspectTeamName} style={{ color: '#de9b35' }}>{tTeamName}</span>
                {tBuyType && <span className={styles.inspectBuyType}>{tBuyType}</span>}
            </div>
            <ReplayScoreboard
                frame={frame}
                roster={replay.roster}
                playerNames={playerNames}
                side="T"
                teamName={tTeamName}
                layout="stacked"
                killCounts={killCounts}
            />
        </>
    );
};

export default AnalysisInspectPanel;
